import React, { useEffect, useState } from 'react';
import { armonizacionContable } from '../../json/armonizacionContable';
import '../DetalleArmonizacionContable/detalleArmonizacionContable.css';

  const DetalleArmonizacionContable2023 = () => {
        useEffect(() => {
          window.scrollTo(0, 0);
  },[]); 

  return (
    <div className='container'>
        <div className='row'>
          <div className='ldf_titulo'>
            <h2>Armonización Contable 2023</h2>
            <hr className='hr-gob'/>
          </div>

            <div style={{ width: "100%" }}>
                <table className="table table-striped table-bordered">
                          <tr>
                            <th scope="col"><div className="detalle_nombreDocumentoAC" style={{ width: "520px" }}>Documento</div></th>
                            <th scope="col"><div style={{ width: "55px" }}>1er_Trim</div></th>
                            <th scope="col"><div style={{ width: "55px" }}>2do_Trim</div></th>
                            <th scope="col"><div style={{ width: "55px" }}>3er_Trim</div></th>
                            <th scope="col"><div style={{ width: "55px" }}>4to_Trim</div></th>
                          </tr>
                </table>
            </div>

            <div className="tabla-contenedorAC">
            <table className="table table-striped table-bordered tabla-elementosAC">
                    <tbody>
                      <tr>
                        <th scope="row" colspan="6"><div className="th-seccion">Información Contable</div></th>
                      </tr>
                      <tr>
                        <td><div ><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Estado Analítico del Activo</div></th>
                          <td>
                            <div style={{ width: "70px" }}>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/EstadoAnaliticodelActivo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div style={{ width: "70px" }}>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/Estado_Analítico_del_Activo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div style={{ width: "70px" }}>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/Estado_Analitico_del_Activo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div style={{ width: "70px" }}>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/Estado_Analitico_del_Activo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Estado de Resultados/Actividades</div></th>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/EstadodeActividades.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/Estado_de_Actividades.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/Estado_de_Actividades.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/Estado_de_Actividades.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Estado de Cambios en la Situación Financiera</div></th>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/EstadodeCambiosenlaSituacionFinanciera.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/EstadodeCambiosenlaSituaciónFinanciera.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/Estado_de_Cambios_en_Situacion_Financiera.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/Estado_de_Cambios_en_Situación_Financiera.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Estado de Flujos de Efectivo</div></th>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/EstadodeFlujosdeEfectivo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/Estado_de_Flujo_de_Efectivo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/Estado_de_Flujos_de_Efectivo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/Estado_de_Flujos_de_Efectivo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Estado de Situación Financiera</div></th>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/EstadodeSituacionFinancieraConsolidado.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/Estado_de_Situacion_Financiera.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/Estado_de_Situacion_Financiera.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/Estado_de_Situacion_Financiera.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Estado de Variación en la Hacienda Pública</div></th>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/EstadodeVariacionenlaHaciendaPublica.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/Estado_de_Variación_en_la_Hacienda_Pública.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/Estado_de_Variaciones_en_la_Hacienda_Publica.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/Estado_de_Variacion_en_la_Hacienda_Publica.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Estado Analítico de la Deuda y Otros pasivos a Corto Plazo</div></th>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/InformeAnaliticodelaDeudayOtrosPasivosCortoPlazo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/Estado_Analitico_de_la_Deuda_y_Otros_Pasivos_Corto_Plazo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/Estado_Analitico_de_la_Deuda_y_Otros_Pasivos_CP.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/Estado_Analitico_de_la_Deuda_y_Otros_Pasivos_CP.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Estado Analítico de la Deuda y Otros pasivos. Fuente de Financiamiento</div></th>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/InformeAnaliticodelaDeudayotrosPasivosFuentedeFinanciamiento.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/Estado_Analitico_de_la_Deuda_y_Otros_Pasivos_Fuente_de_Financiamiento.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/Estado_Analitico_de_la_Deuda_y_Otros_Pasivos_FF.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/Estado_Analitico_de_la_Deuda_y_Otros_Pasivos_FF.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Estado Analítico de la Deuda y Otros pasivos a Largo Plazo</div></th>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/InformeAnaliticodelaDeudayOtrosPasivosLargoPlazo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/Estado_Analitico_de_la_Deuda_y_Otros_Pasivos_Largo_Plazo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/Estado_Analitico_de_la_Deuda_y_Otros_Pasivos_LP.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/Estado_Analitico_de_la_Deuda_y_Otros_Pasivos_LP.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Estado Analítico de la Deuda y Otros pasivos. Intereses de la Deuda</div></th>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/InformeAnaliticodelaDeudayOtrosPasivosInteresesdelaDeuda.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/Estado_Analitico_de_la_Deuda_y_Otros_Pasivos_Intereses_de_la_Deuda.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/Estado_Analitico_de_la_Deuda_y_Otros_Pasivos_ID.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/Estado_Analitico_de_la_Deuda_y_Otros_Pasivos_ID.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Estado Analítico de la Deuda y Otros pasivos</div></th>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/InformeAnaliticodelaDeudayOtrosPasivos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/Estado_Analítico_de_la_Deuda_y_Otros_Pasivos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/Estado_Analitico_de_la_Deuda_y_Otros_Pasivos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/Estado_Analitico_de_la_Deuda_y_Otros_Pasivos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Informe de Pasivos Contingentes</div></th>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/InformeSobrePasivosContingentes.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/Pasivos_Contingentes.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/Pasivos_Contingentes.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/Pasivos_Contingentes.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Notas a los Estados Financieros</div></th>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/NotasalosEstadosFinancieros.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/Notas_a_los_Estados_Financieros.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/Notas_a_los_Estados_Financieros.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/Notas_a_los_Estados_Financieros.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                        </tr>
                      
                      <tr>
                        <th scope="row" colspan="6"><div className="th-seccion">Información Presupuestaria</div></th>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Estado Analítico del Ingreso, clasificación económica por fuente de financiamiento y concepto</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/1Estado_Analitico_de_Ingresos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/1Estado_Analitico_de_Ingresos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/1Estado_Analitico_de_Ingresos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/1Estado_Analitico_de_Ingresos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Estado Analítico del Ejercicio del Presupuesto de Egresos, (Administrativa)</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/2EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacion_Administrativa.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/2EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacion_Administrativa.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/2EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacion_Administrativa.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/2EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacion_Administrativa.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Estado Analítico del Ejercicio del Presupuesto de Egresos. Clasificación Económica por tipo de Gasto</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/3EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacionEconomica(Por_Tipo_de_Gasto).pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/3EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacionEconomica(Por_Tipo_de_Gasto).pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/3EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacionEconomica(Por_Tipo_de_Gasto).pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/3EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacionEconomica(Por_Tipo_de_Gasto).pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Estado Analítico del Ejercicio del Presupuesto de Egresos. Clasificación por objeto del gasto</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/4EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacionporObjeto_del_Gasto(Capitulo_y_Concepto).pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/4EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacionporObjeto_del_Gasto(Capitulo_y_Concepto).pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/4EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacionporObjeto_del_Gasto(Capitulo_y_Concepto).pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/4EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacionporObjeto_del_Gasto(Capitulo_y_Concepto).pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Estado Analítico del Ejercicio del Presupuesto de Egresos. Clasificación Funcional</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/5EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacionFuncional(Finalidad_y_Funcion).pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/5EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacionFuncional(Finalidad_y_Funcion).pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                           <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/5EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacionFuncional(Finalidad_y_Funcion).pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/5EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacionFuncional(Finalidad_y_Funcion).pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Endeudamiento Neto</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/6EndeudamientoNeto.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/6EndeudamientoNeto.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/6EndeudamientoNeto.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                        <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/6EndeudamientoNeto.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Intereses de la Deuda</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/7InteresesdelaDeuda.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/7InteresesdelaDeuda.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/7InteresesdelaDeuda.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/7InteresesdelaDeuda.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Indicadores de Postura Fiscal</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/8FlujodeFondos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/8Indicadores_de_Postura_Fiscal.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/8Flujo_de_Fondos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/8Indicadores_de_Postura_Fiscal.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                      </tr>
                     
                      <tr>
                        <th scope="row" colspan="6"><div className="th-seccion">Información Programática</div></th>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Gasto por Categoría Programática</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/9GastoporCategoriaProgramatica.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/9GastoporCategoriaProgramatica.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/9GastoporCategoriaProgramatica.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/9GastoporCategoriaProgramatica.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Indicadores de Resultados</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/IR-UTED_1erTrim2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/IR-UTED_2doTrim2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/IR_DIF_03_2023_firmado.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/IR_4toTrim2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Programas y Proyectos de Inversión</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/PPI_1erTrim2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/PPI_2doTrim2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/PPI_DIF_03_2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/PPI_4toTrim2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                      </tr>

              
                      <tr>
                        <th scope="row" colspan="6"><div className="th-seccion">Inventarios</div></th>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Inventario de Bienes Muebles</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/RBMI_DIF_1ER_TRIM_2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/RBMI_DIF_2DO_TRIM_2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/RBMI_DIF_03_2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/RBMI_DIF_04_2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Inventario de Bienes Inmuebles</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/RBIM_DIF_01_2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/RBIM_DIF_02_2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/RBIM_DIF_03_2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/RBIM_DIF_04_2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                      </tr>

                      
                      <tr>
                        <th scope="row" colspan="6"><div className="th-seccion">Información Adicional</div></th>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Información para la Difusión de la Ley de Ingresos y del Presupuesto de Egresos</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/Información_para_la_Difusión_de_la_Ley_de_Ingresos_y_del_Presupuesto_de_Egresos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Información del Calendario de Ingresos base mensual</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/Estructura_del_Calendario_de_Ingresos_base_mensual_NOR_01_14_004.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Información del Calendario de Egresos base mensual</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/Calendario_del_presupuesto_de_Egresos_del_ejercicio_fiscal_NOR_01_14_005.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Información Adicional a la Iniciativa de la Ley de Ingresos</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/Informacion_adicional_a_la_iniciativa_de_la_Ley_de_Ingreos_NOR_01_14_001.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Información Adicional al Proyecto de Presupuesto de Egresos</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/Informacion_adicional_al_proyecto_del_Presupuesto_de_Egresos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Calendario de Programación Presupuestal</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/Calendario_del_Gasto_1Trim2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>

                      
                      <tr>
                        <th scope="row" colspan="6"><div className="th-seccion">Normas</div></th>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Montos Pagados por Ayudas y Subsidios</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/AYUDAS_Y_SUBSIDIOS_1ER_TRIM_2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/AYUDAS_Y_SUBSIDIOS_2doTRIM_2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/Ayudas_y_subsidios_tercer_trim_2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/Ayudas_y_Subsidios_DIFH_4to_Trim2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                      </tr>
                    </tbody>
              </table>
            </div>

          </div>
      </div>        


//
//  <div className="contenedor-tablaLDF">
//                {
//                  armonizacionContable.map((item, index)=>(
//                     
//                              <div className="th-seccion" key={index}> {item.seccion} </div>
//                          
//                            {
//                                item.documentos.map((doc, n)=>(
//                                 <div key={ n }>
//                                      
//                                        <div className="detalle_iLDF"><i className="fas fa-file-pdf"></i></div>
//                                      
//                                        <div className="detalle_documentoLDF"> {doc.documentoItem} </div>
//                                      
//                                         {
//                                            doc.trimestres.map((trim, x)=>(
//                                                  
//                                                    <div className="div-elementosLDF" key={x}>
//                                                        <a href={ trim.link1erTrim } target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-pdf" type="button">PDF</button></a>
//                                                    </div>
//                                                  
//                                                  
//                                                    <div className="div-elementosLDF" key={ x }>
//                                                        <a href={ trim.link2doTrim } target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-pdf" type="button">PDF</button></a>
//                                                    </div>
//                                                  
//                                                  
//                                                    <div className="div-elementosLDF" key={ x }>
//                                                        <a href={ trim.link3erTrim } target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-pdf" type="button">PDF</button></a>
//                                                    </div>
//                                                  
//                                                  
//                                                    <div className="div-elementosLDF" key={ x }>
//                                                        <a href={ trim.link4toTrim } target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-pdf" type="button">PDF</button></a>
//                                                    </div>
//                                                  
//                                            ))
//                                          } 
//                                  </div>
//                              ))
//                           } 
//                  ))
//                }  
//          </div>         
//       </div>
//      </div>
//    )

 //   }  

    
  )
}


  export default DetalleArmonizacionContable2023